var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center-container"},[_vm._v("\n  页面正在开发中...\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }